import React, { useState } from 'react';

import Table from '~components/molecules/Table';
import Text from '~components/atoms/Text';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, MetalTypeEnum } from '~utils/enums';

import UtilFunctions from '~utils/functions';
import * as Styles from './InventoryReportTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';
import InventoryBranchReportTablePaginator from '../InventoryBranchReportTablePaginator';
import Image from '~components/atoms/Image';

const InventoryBranchReportTable = () => {
    const inventoryBranchReportListing = useAppSelector(state => state.report.inventoryReport.inventoryBranchReportListing.data);

    const isLoading = useAppSelector(state => state.report.loadings.getInventoryBranchReportListing);
    const isError = useAppSelector(state => state.report.errors.getInventoryBranchReportListing);

    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);
    const [serialNoList, setSerialNoList] = useState<string[]>([]);

    const tableHeader = [
        'IMAGE',
        'PRODUCT NAME',
        'METAL TYPE',
        'BRANCH',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL WEIGHT (G)',
        'FUND TYPE',
    ];

    const tableBody = inventoryBranchReportListing.map(transaction => {
        const {
            inventoryId,
            productName,
            metalType,
            branchName,
            serialNumbers,
            quantity,
            totalWeight,
            fundType,
            image,
        } = transaction;

        const handleViewSerialNo = () => {
            if (!serialNumbers) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNumbers);
        };

        const renderSerialNo = () => {
            if (!serialNumbers) return '-';

            return (
                <ActionButton
                    key={inventoryId}
                    label='View'
                    onClick={handleViewSerialNo}
                />
            );
        };

        return {
            cells: [
                <Image
                    key={inventoryId}
                    src={image || ''}
                    width={40}
                    height={40}
                />,
                productName,
                MetalTypeEnum[metalType],
                branchName,
                renderSerialNo(),
                quantity,
                totalWeight.toFixed(3),
                FundTypeEnum[fundType],
            ],
        }
    });

    return (
        <>
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
                error={isError}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />

            <InventoryBranchReportTablePaginator />
        </>
    );
};

export default InventoryBranchReportTable;
